
define('text!templates/awards-profile-menu.html',[],function () { return '<li class="item14 <% if(isActive) print(\'isactive\');%> profile-item-awards">\n    <a href="/profile.php?section=fields&id=<%=userId%>&p=awards"><%=Config.modules.awards.title%></a>\n</li>\n';});

